import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";

//E-commerce
import ecommerce from "./e-commerce/reducer";

//Calendar
//import calendar from "./calendar/reducer";

//chat
import chat from "./chat/reducer";

//crypto
import crypto from "./crypto/reducer";

//invoices
//import invoices from "./invoices/reducer";

//jobs
import JobReducer from "./jobs/reducer";




// Roles
import roleReducer from "./roles/reducer";

// Features
import featureReducer from "./features/reducer";

// Actions
import actionReducer from "./actions/reducer";

// Permissions
import permissionReducer from "./permissions/reducer";

// Role Permissions
import rolePermissionReducer from "./role-permissions/reducer";

// Accounts
import accountReducer from "./accounts/reducer";

// Profile
import profileReducer from "./profile/reducer";




// FACULTIES
import facultyReducer from "./faculties/reducer";

// DEPARTMENTS
import departmentReducer from "./departments/reducer";

// SERVICES
import serviceReducer from "./services/reducer";

// Invoices
import invoiceReducer from "./invoices/reducer";

// TRAINING TYPES
import trainingTypeReducer from "./training-types/reducer";

// Branchs
import branchReducer from "./branches/reducer";

// Study levels
import studyLevelReducer from "./study-levels/reducer";

// Internship Structures
import internshipStructureReducer from "./internship-structures/reducer";

// Document types
import documentTypeReducer from "./document-types/reducer";

// Courses components
import courseComponentReducer from "./course-components/reducer";

// Titles
import titleReducer from "./titles/reducer";

// Course units
import courseUnitReducer from "./course-units/reducer";

// Teachers
import teacherReducer from "./teachers/reducer";

// Pre-registrations
import preRegistrationReducer from "./pre-registrations/reducer";

// Students
import studentReducer from "./students/reducer";

// Evaluations
import evaluationReducer from "./evaluations/reducer";

// Notes
import noteReducer from "./notes/reducer";

// Registrations
import registrationReducer from "./registrations/reducer";


// Internships
import internshipReducer from "./internships/reducer";

// Interships services
import internshipServiceReducer from "./internship-services/reducer";

// Document resuests
import documentRequestReducer from "./document-requests/reducer";

// Defenses
import defenseReducer from "./defenses/reducer";

// File types
import fileTypeReducer from "./file-types/reducer";

// Feature file types
import featureFileTypeReducer from "./feature-file-types/reducer";

// PRESTATIONS
import prestationReducer from "./prestations/reducer";

// FEE TYPES
import feeTypeReducer from "./fee-types/reducer";

// PRE REGISTRATION REJECTIONS
import preRegistrationRejectionReducer from "./pre-registration-rejections/reducer";

// SEMESTERS
import semesterReducer from "./semesters/reducer";

// ACADEMIC YEARS
import academicYearReducer from "./academic-years/reducer";

// ANONYMOUS EXAM RECORDS
import anonymousExamRecordReducer from "./anonymous-exam-records/reducer";

// PRE REGISTRATION CONFIGURATIONS
import preRegistrationConfigurationReducer from "./pre-registration-configurations/reducer";

// MENTIONS
import mentionReducer from "./mentions/reducer";

// SESSION TYPES
import sessionTypeReducer from "./session-types/reducer";

// SESSIONS
import sessionReducer from "./sessions/reducer";

// EXAM ROOMS
import examRoomReducer from "./exam-rooms/reducer";

// EXAM ROOM ASSIGNMENTS
import examRoomAssignmentReducer from "./exam-room-assignments/reducer";

// EVALUATION TYPES
import evaluationTypeReducer from "./evaluation-types/reducer";


// FINAL DECISIONS
import finalDecisionReducer from "./final-decisions/reducer";

// FINAL DECISIONS
import academicCycleConfigReducer from "./academic-cycle-configs/reducer";


//projects
import projects from "./projects/reducer";

//tasks
import tasks from "./tasks/reducer";

//contacts
import contacts from "./contacts/reducer";

//mails
import mails from "./mails/reducer";

//Dashboard 
import Dashboard from "./dashboard/reducer";

//Dasboard saas
import DashboardSaas from "./dashboard-saas/reducer";

//Dasboard crypto
import DashboardCrypto from "./dashboard-crypto/reducer";

//Dasboard blog
import DashboardBlog from "./dashboard-blog/reducer";

//Dasboard job
import DashboardJob from "./dashboard-jobs/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ecommerce,
  //calendar,
  chat,
  mails,
  crypto,
  //invoices,
  JobReducer,
  profileReducer,
  facultyReducer,
  departmentReducer,
  serviceReducer,
  trainingTypeReducer,
  branchReducer,
  studyLevelReducer,
  internshipStructureReducer,
  documentTypeReducer,
  courseUnitReducer,
  titleReducer,
  courseComponentReducer,
  teacherReducer,
  preRegistrationReducer,
  studentReducer,
  evaluationReducer,
  noteReducer,
  registrationReducer,
  internshipReducer,
  internshipServiceReducer,
  documentRequestReducer,
  defenseReducer,
  fileTypeReducer,
  featureFileTypeReducer,
  prestationReducer,
  feeTypeReducer,
  preRegistrationRejectionReducer,
  semesterReducer,
  academicYearReducer,
  anonymousExamRecordReducer,
  preRegistrationConfigurationReducer,
  mentionReducer,
  sessionTypeReducer,
  sessionReducer,
examRoomReducer,
    examRoomAssignmentReducer,
    evaluationTypeReducer,
     finalDecisionReducer,
     academicCycleConfigReducer,
  



  actionReducer,
  roleReducer,
  featureReducer,
  accountReducer,
  permissionReducer,
  rolePermissionReducer,

  

 
  invoiceReducer,
  projects,
  tasks,
  contacts,
  Dashboard,
  DashboardSaas,
  DashboardCrypto,
  DashboardBlog,
  DashboardJob
});

export default rootReducer;
